import React from "react";

type State = { err: Error | null; info: string | null };

export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { err: null, info: null };

  static getDerivedStateFromError(err: Error): State {
    return { err, info: null };
  }

  componentDidCatch(err: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary] render error:", err, info);
    this.setState({ err, info: info.componentStack ?? null });
  }

  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="main">
        <div className="card">
          <h3 style={{ color: "var(--danger)" }}>Render error</h3>
          <p className="mono" style={{ whiteSpace: "pre-wrap" }}>
            {this.state.err.message}
          </p>
          <details style={{ marginTop: "1rem" }}>
            <summary className="muted">Stack</summary>
            <pre
              className="mono"
              style={{ whiteSpace: "pre-wrap", fontSize: "0.8rem", color: "var(--text-dim)" }}
            >
              {this.state.err.stack}
              {this.state.info && "\n\nComponent stack:\n" + this.state.info}
            </pre>
          </details>
          <button onClick={() => location.reload()} style={{ marginTop: "1rem" }}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}
